import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import {
  Autocomplete,
  Chip,
  FormControl,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import useStateList from "../../Component/GetStateList";
import { useFormik } from "formik";
import * as Yup from "yup";
import { API_POST } from "../../API/config";
import { toast } from "react-toastify";
import { API_endspoints } from "../../API/API_endspoints";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "12px",
  p: 4,
};

export default function AddStateModal({ type, id, getData, handleClose1 }) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { stateList } = useStateList(null);

  const formik = useFormik({
    initialValues: {
      id: id,
      state_ids: [],
    },
    validationSchema: Yup.object({
      state_ids: Yup.array().min(1, "Required"),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      try {
        setSubmitting(true);
        const f = new FormData();
        f.append("state_ids", values.state_ids);
        type === 1
          ? f.append("company_id", values.id)
          : f.append("truck_id", values.id);
        let api =
          type === 1
            ? API_endspoints.addUpdateCompanyState
            : API_endspoints.addUpdateFoodTruckState;
        let res = await API_POST(api, f);
        if (res.s) {
          toast.success("State added Successfully");
          getData();
          handleClose();
          handleClose1();
          formik.resetForm();
        } else {
          toast.error(res.m);
        }
        setSubmitting(false);
      } catch (error) {}
    },
  });
  return (
    <div>
      <Button
        sx={{
          color: "#FFF",
          px: 2,
          textTransform: "none",
          background: "#164fa1",
          borderRadius: "12px",
          "&:hover": {
            background: "#164fa1",
            color: "#FFF",
          },
        }}
        onClick={handleOpen}
      >
        Add State
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            sx={{
              pb: 1.5,
              fontWeight: "600",
            }}
          >
            Add State
          </Typography>
          <FormControl
            fullWidth
            error={formik.touched.state_ids && Boolean(formik.errors.state_ids)}
            sx={{
              color: "#000",
              textAlign: "start",
              borderRadius: "12px",
            }}
          >
            <Autocomplete
              multiple
              sx={{
                borderRadius: "12px",
                //   "&:hover": {
                //       color: theme.palette.text.active,
                //       bgcolor: theme.palette.background.inputBg,
                //   },
                //   "&:active": {
                //       color: theme.palette.text.active,
                //       bgcolor: theme.palette.background.inputBg,
                //   },
              }}
              id="state_ids"
              name="state_ids"
              options={stateList || []}
              getOptionLabel={(option) => option.state_name}
              value={
                stateList?.filter((m) =>
                  formik.values.state_ids?.includes(m.id)
                ) || []
              }
              onChange={(event, newValue) => {
                formik.setFieldValue(
                  "state_ids",
                  newValue.map((m) => m.id)
                );
              }}
              onBlur={formik.handleBlur}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={
                    !params?.InputProps?.startAdornment?.length
                      ? "Select state"
                      : null
                  }
                  error={
                    formik.touched.state_ids && Boolean(formik.errors.state_ids)
                  }
                  helperText={
                    formik.touched.state_ids && formik.errors.state_ids
                  }
                  sx={{
                    "& .MuiInputBase-input": {
                      color: "#000",
                    },
                    "& .MuiInputLabel-root": {
                      // color: "#164FA1",
                      color: "grey",
                    },
                    // "& .MuiInputLabel-root.Mui-focused": {
                    //   color: theme.palette.background.strip,
                    // },
                    "& .MuiFormHelperText-root": {
                      color: "#164FA1",
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderRadius: "12px",
                        borderColor: `1px solid #DEE6F252`,
                      },
                    },
                  }}
                />
              )}
              renderTags={(value, getTagProps) =>
                value?.map((option, index) => (
                  <Chip
                    key={option.id}
                    label={option?.state_name}
                    {...getTagProps({ index })}
                    sx={{
                      color: "#000",
                      "& .MuiChip-deleteIcon": {
                        color: "black",
                      },
                    }}
                  />
                ))
              }
              PaperComponent={({ children }) => (
                <Paper
                  sx={{
                    bgcolor: "#DEE6F252",
                    color: "grey",
                  }}
                >
                  {children}
                </Paper>
              )}
              ListboxProps={{
                sx: {
                  bgcolor: "#FFF",
                  color: "#000",
                  "& .MuiAutocomplete-option": {
                    "&:hover": {
                      color: "#fd5d29",
                    },
                  },
                },
              }}
            />
          </FormControl>
          <Button
            type="submit"
            onClick={formik.handleSubmit}
            variant="contained"
            disabled={formik.isSubmitting}
            sx={{
              width: "100%",
              textTransform: "none",
              borderRadius: "8px",
              mt: 2,
              mx: "auto",
              backgroundColor: "#164FA1",
              "&:hover": {
                backgroundColor: "#164FA1",
              },
              "&:disabled": {
                background: "gray", // Style for the disabled button
              },
            }}
          >
            Submit
          </Button>
        </Box>
      </Modal>
    </div>
  );
}
